import {makeGetProvidersDetailsMedicalGuide} from 'main/factories/usecases';
import {HealthProviderDetailsParams} from './types';

export async function getHealthProviderDetails(params: HealthProviderDetailsParams) {
	const response = await makeGetProvidersDetailsMedicalGuide().get(params);
	return response;
}
